import { useTranslation } from 'react-i18next'
import { Layout } from '../components/Layout'

export function NotFound() {
  const { t } = useTranslation()
  return (
    <Layout>
      <div className="flex items-center justify-center h-full">
        <div className="text-center space-y-4">
          <h1 className="text-6xl font-bold text-foreground">
            {t('404.title', { defaultValue: '404' })}
          </h1>
          <p className="text-lg text-muted-foreground">
            {t('404.description', { defaultValue: 'Page not found' })}
          </p>
        </div>
      </div>
    </Layout>
  )
}
